import axios from "../axios/index.js";

const urlGetCustomerList = "/api/customer/get-list";
const urlUpdateCustomer = "/api/customer/update/";
const urlGetCustomerDetail = "/api/customer/detail/";
const urlGetCustomerAuth = "/api/get-customer-auth";

export default {
    getList(params) {
        return axios.get(urlGetCustomerList, {
            params: params
        });
    },

    getDetail(id) {
        return axios.get(urlGetCustomerDetail + id);
    },

    update(params) {
        return axios.post(urlUpdateCustomer + params.id, params);
    },

    getCustomerAuth() {
        return axios.post(urlGetCustomerAuth);
    },
};
